angular.module('lsnBase.deprecated.models')
  .factory('IcOrganizationUnitModel', ['LsnIcOrganizationUnitModelV1',
    function(LsnIcOrganizationUnitModelV1) {
      return LsnIcOrganizationUnitModelV1;
    }
  ]);